export const STATI = {
  "awaiting compilation": 1,
  compiled: 2,
  "compilation confirmed": 3,
  "awaiting evaluation": 4,
  finalized: 5,
  "evaluation confirmed": 5,
};
